export default __webpack_public_path__ + "static/media/pg-42.d96f6464.jpg";